module.exports = __webpack_public_path__ + "static/img/8.5fc712e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/8.png
// module id = Q2Wq
// module chunks = 0